import { Button, cn } from '@risksmart-app/atomic-ui';

export const SlideOutDiscardButton = ({
  visible,
  onDiscard,
}: {
  visible: boolean;
  onDiscard: () => void;
}) => (
  <div
    aria-hidden={!visible}
    className={cn(
      'relative overflow-hidden transition-all ease-out duration-300',
      visible ? 'max-w-[180px] opacity-100' : 'max-w-0 opacity-0'
    )}
  >
    <Button
      variant={'destructive'}
      style={'outline'}
      className={'whitespace-nowrap'}
      onClick={onDiscard}
    >
      {'Discard changes'}
    </Button>
    <div
      className={cn(
        'pointer-events-none absolute inset-y-0 right-0 w-8 transition-opacity duration-75',
        visible ? 'opacity-0' : 'opacity-100'
      )}
      style={{
        background:
          'linear-gradient(to right, transparent, oklch(var(--neutral)))',
      }}
    />
  </div>
);
